module.exports = __webpack_public_path__ + "static/media/banner-pesquisa-usabilidade-indecx.c575c60f.jpg";